/**
 * Created by BFR on 24/02/2020.
 */
define('editPimCatView',[
    'module',
    'marionette',
    'app',
    'underscore',
    'template!editPimCatTpl',
    'dynamicTextView',
    'editPimOptionsView',
    'pimUtil'
  ], function(
    module,
    Marionette,
    App,
    _,
    viewTpl,
    DynamicTextView,
    EditPimOptionsView,
    PimUtil
  ) {
    'use strict';
  
    var EditPimCatView =  Marionette.LayoutView.extend({
      template: viewTpl,
      className: 'cat-item',
  
      regions: {
        nameRegion: '.name-region',
        editOptions: '.options-region'
      },

      onShow: function () {
        this.editPimOptionsView = new EditPimOptionsView({
          pimProduct: this.options.pimProduct, 
          collection: this.model.get('productOptions')
        });
        this.getRegion('editOptions').show(this.editPimOptionsView);
      },
  
      serializeData: function () {
        var templateData = {};

        templateData.code = this.model.get('code');

        var aNames = this.model.get('name').values;

        templateData.name = PimUtil.getTranslation(aNames);         

        return templateData;
      }
    });
  
    module.exports = EditPimCatView;
  });
